module.exports = __webpack_public_path__ + "img/clinicbanner.ccf4baea.jpg";